import { createClient, PlainClientAPI } from 'contentful-management';
import { Blog, BlogContent } from 'domain/blog-content';
import { ExploraEntries } from 'domain/contentful/explora-entries';
import { getContentFromContentful } from 'shared/util/contentful/contentful';

interface ContentfulEntryKeys {
  [key: string]: string | number;
}

interface CreateContentfulManagementInterface {
  spaceId: string;
  accessToken: string;
  environmentId: string;
}

const version = 'v1';

let client: PlainClientAPI;

export const createContentfulManagementClient = ({ spaceId, accessToken, environmentId }: CreateContentfulManagementInterface): void => {
  /* istanbul ignore else */
  if (!client) {
    client = createClient(
      { accessToken },
      {
        type: 'plain',
        defaults: {
          spaceId,
          environmentId,
        },
      },
    );
  }
};

const headers = {
  'Content-Type': 'application/json',
};

const generateContentfulEntryKeys = (item: ContentfulEntryKeys) => {
  return Object.keys(item).reduce((entry: { [key: string]: ContentfulEntryKeys }, key) => {
    entry[key] = {
      'en-US': item[key],
    };
    return entry;
  }, {});
};

const getHomeContent = async () => {
  const data : any = [];
  let lastReleases : any = [];
  await getContentFromContentful<any>(ExploraEntries.Home)
  .then((q) => {
    data.push(q.fields.data);
    lastReleases = q.fields.podcasts;
  });

  if(data.length > 0) {
    return {homeContent: data[0], LastReleases: lastReleases};
  }

  const error = { code: 'Error', message: 'Please Contact your Web Master' };
  throw error;
};

const getProductionsContent = async () => {
  const data : any = [];
  let allLaunches : any = {};
  await getContentFromContentful<any>(ExploraEntries.Production)
  .then((q) => {
    data.push(q.fields.data);
    allLaunches = q.fields.podcasts;
  });

  if(data.length > 0) {
    return {productionContent: data[0], allLaunches: allLaunches};
  }

  const error = { code: 'Error', message: 'Please Contact your Web Master' };
  throw error;
};

const getUsContent = async () => {
  const data : any = [];
  await getContentFromContentful<any>(ExploraEntries.Us)
  .then((q) => {
    data.push(q.fields.data);
  });

  if(data.length > 0) {
    return data[0]
  }

  const error = { code: 'Error', message: 'Please Contact your Web Master' };
  throw error;
};

const getBlogContent = async () => {
  const data : any = [];
  let articles : any = [];

  await getContentFromContentful<any>(ExploraEntries.Blog)
  .then((q) => {
    const tempData : BlogContent = q.fields.data;
    tempData.podcastingContent = q.fields.articles;

    data.push(tempData);
  });

  if(data.length > 0) {
    return data[0];
  }

  const error = { code: 'Error', message: 'Please Contact your Web Master' };
  throw error;
};

const subscribeUser = async (name: string, email: string, policyAccepted: boolean) => {

  const product = await client.entry.create(
    { contentTypeId: 'subscriber' },
    {
      fields: {
        ...generateContentfulEntryKeys({ name: name, email: email, policyAccepted: policyAccepted.toString() }),
      },
    },
  );

};

const contactExplora = async (name: string, email: string, subject: string, body: string, policyAccepted: boolean) => {
  const product = await client.entry.create(
    { contentTypeId: 'subscriber' },
    {
      fields: {
        ...generateContentfulEntryKeys({ name: name, email: email, subject: subject, body:body ,policyAccepted: policyAccepted.toString() }),
      },
    },
  );
};

export const ExploraRequest = {
  getHomeContent,
  getProductionsContent,
  getUsContent,
  getBlogContent,
  subscribeUser,
  contactExplora,
  createContentfulManagementClient
};
